import { AdminPermissionGroups } from './AdminPermissionGroups';
import { GLOBAL_ADMIN_PERMISSION, SUPER_ADMIN_PERMISSION } from './AdminPermissions';
export function canAccessPagePermission(pagePermission, adminPermissionGroups) {
    return adminPermissionGroups.some((adminPermissionGroupName) => {
        const pagePermissions = AdminPermissionGroups[adminPermissionGroupName].pagePermissions;
        if (pagePermissions.includes(GLOBAL_ADMIN_PERMISSION)) {
            return true;
        }
        return pagePermissions.includes(pagePermission);
    });
}
export function canAccessEndpointPermission(endpointPermissionDescription, adminPermissionGroups) {
    return adminPermissionGroups.some((adminPermissionGroupName) => {
        const endpointPermissions = AdminPermissionGroups[adminPermissionGroupName].endpointPermissions;
        if (endpointPermissions.includes(GLOBAL_ADMIN_PERMISSION)) {
            return true;
        }
        if (endpointPermissions.some((endpointPermission) => {
            return (endpointPermission.endsWith('/*') &&
                new RegExp('^' + endpointPermission.replace(/\/\*/g, '.*') + '$').test(endpointPermissionDescription.endpointPath));
        })) {
            return true;
        }
        if (endpointPermissions.some((endpointPermission) => {
            const [epPath, epAccessType] = endpointPermission.split('.');
            if (endpointPermissionDescription.endpointPath.startsWith(epPath)) {
                if (epAccessType === '*' || epAccessType === endpointPermissionDescription.endpointAccessType) {
                    return true;
                }
            }
            return false;
        })) {
            return true;
        }
        return false;
    });
}
export const isPathSuperAdminPermissions = (path) => {
    for (const groupKey in AdminPermissionGroups) {
        const group = AdminPermissionGroups[groupKey];
        if (group.pagePermissions.includes(SUPER_ADMIN_PERMISSION) &&
            group.endpointPermissions.some((endpointPermission) => {
                return (endpointPermission.endsWith('/*') &&
                    new RegExp('^' + endpointPermission.replace(/\/\*/g, '.*') + '$').test(path));
            })) {
            return true;
        }
    }
    return false;
};
